



































































































































































































































































































































































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import {
  RimRepairLayoutComponent,
  RimRepairAutocompleteComponent,
	RimRepairModalComponent
} from "@/components/common";
import {
  IWorkOrder,
  ICustomer,
  IServiceTodo,
  IServiceTodoDefinition,
  IServiceDone,
  IServiceDoneDefinition,
  IStaff,
  Callback,
} from "@/interfaces";
import { makeWorkOrder, formatDate, makeStaff, makeCustomer } from "@/utils";
import {
  GetWorOrder,
  SearchCustomers,
  InsertWorOrder,
  GetCustomer,
  UpdateWorOrderOffice,
  UpdateWorOrderTech,
  InsertCustomer,
} from "@/api";
import { Getter, Action } from "vuex-class";
import {
  YEAR_RULES,
  MODEL_RULES,
  MAKE_RULES,
  REPAIR_DESCRIPTION_RULES,
} from "@/validators";
import { UserInterface } from "@/utils/UserInterface";
import CustomerTabs from "../office/customer-tabs.vue";

@Component({
  components: {
    RimRepairLayoutComponent,
    RimRepairAutocompleteComponent,
		RimRepairModalComponent,
	  CustomerTabs
  },
})
export default class WorkOrderFormComponent extends Vue {
  @Getter("servicesToDo", { namespace: "AppModule" })
  public servicesToDo!: IServiceTodoDefinition[];
  @Getter("servicesDone", { namespace: "AppModule" })
  public servicesDone!: IServiceDoneDefinition[];
  @Getter("technician", { namespace: "AppModule" })
  public technicians!: IStaff[];
  @Action("setSnackbar", { namespace: "AppModule" })
  public setSnackbarAction!: Callback;
  public workOrder: IWorkOrder = makeWorkOrder({});
  public valid = true;
  public menu = false;
  public buttonLoading = false;
  public id: number | null = null;
  public defaultCustomer = 0;
  public servicesToDoState: IServiceTodo[] = [];
  public servicesDoneState: IServiceDone[] = [];
  public disabledForm1 = false;
  public disabledForm2 = false;
  public disabledForm3 = false;
  public redirect = "/office/work-orders";
  public type = "";
  public tab: number | null = null;
  public yearRules = YEAR_RULES;
  public modelRules = MODEL_RULES;
  public makeRules = MAKE_RULES;
  public repairDescriptionRules = REPAIR_DESCRIPTION_RULES;
  public isReadOnly: boolean = false;
  public ShowNewCustomerDialog: boolean = false;
  public InsertingCustomer: ICustomer = makeCustomer({});
	private UI__: UserInterface;

  mounted() {

		/* WAIT FOR NEXT TICK, SINCE WE NEED TO USE
		A ROUTE META VALUE THAT IS NOT READILY AVAILABLE.
		*/
		this.$nextTick(()=>{
				this.changeDisabled();
		});

    this.UI__ = new UserInterface(this);

    this.type = this.$route.params.type;
    this.setRedirect();
    this.id = +this.$route.params.id || null;
    // this.defaultCustomer = +this.$route.params.customerId;
    if (this.type === "technician") {
      this.tab = 2;
    }
    if (this.id) {
      this.getWorkOrder();
    } else {
      if (this.servicesToDo.length) {
        this.formatServicetoDo();
        this.formatServiceDone();
      }
    }

  }


  public CreateNewCustomer(): void {
    this.ShowNewCustomerDialog = true;
  }

  public CancelCreating(): void {
    this.ShowNewCustomerDialog = false;
  }


  public async CreateCustomerBegin() {
    var isValid: boolean = (this.$refs
      .frmNewcust as HTMLFormElement).validate();

    if (isValid) {
      // this.buttonLoading = true;

      this.UI__.TurnBlockerOn();
      let resp = await InsertCustomer(this.InsertingCustomer);

      // this.buttonLoading = false;
      if (resp.Ok) {
        let cust = await GetCustomer(resp.CustomerID);

        if (!cust.Ok) {
          /*
					ERROR WHILE RETRIEVING THE RECENTLY CREATED CUSTOMER
					*/
          this.UI__.SnacError(
            "Error retrieving the recently created customer: " + cust.Msg
          );

          /*
				CLOSE AND RESET THE INSERT DIALOG, SINCE THE CUSTOMER WAS INSERTED
				ANYWAY.
				*/
        } else {
					// this.updateCustomer(cust.Customer);

					/* MAKING SURE TO SELECT THE NEW CUSTOMER
					*/
					this.workOrder.CustomerID= cust.Customer.RecordID;
					this.defaultCustomer = cust.Customer.RecordID;

          this.UI__.SnacSuccess(`Customer Created Successfully !`);
        }

        this.InsertingCustomer = makeCustomer({});

        this.ShowNewCustomerDialog = false;
      } else {
        this.UI__.SnacError(resp.Msg);
      }

      this.UI__.TurnBlockerOff();
    } else {
      this.UI__.SnacError(
        `Check for Validation Erros in Billing or Shipping tabs`
      );
    }
  }



private ShowStaff(s:IStaff):string{
	if (s.RecordID==-1)return "Not Applicable";
	return s.FName +" "+ s.LName + " ["+s.Initials+"]";
}

get getTechnicians(): IStaff[]{
 	var rval = [...this.technicians];
	 var s : IStaff = makeStaff({});
	 s.RecordID = -1;
	 rval.unshift(s)
	return rval;
}

  changeDisabled() {
    this.disabledForm1 =
      this.type === "technician" || this.type === "shop-manager";
    this.disabledForm2 =
      this.type === "technician" || this.type === "shop-manager";
		this.disabledForm3 = this.type === "office" || this.type === "shop-manager";
		
		var disabled = this.$route.meta.IsViewing===true;

		this.disabledForm1=disabled;
		this.disabledForm2=disabled;
		this.disabledForm3=disabled;

		this.isReadOnly = disabled;

  }

  setRedirect() {
    if (this.type === "technician") {
      this.redirect = "/technician";
    } else if (this.type === "office") {
      this.redirect = "/office/work-orders";
    } else if (this.type === "shop-manager") {
      this.redirect = "/shop-manager";
    }
  }

  @Watch("servicesToDo")
  public formatST() {
    if (!this.id) {
      this.formatServicetoDo();
    }
  }

  @Watch("servicesDone")
  public formatSD() {
    if (!this.id) {
      this.formatServiceDone();
    }
  }

  formatServiceDone() {
    this.servicesDoneState = this.servicesDone.map((s) => {
      const service: IServiceDone = {
        Name: s.Name,
      };
      return service;
    });
  }

  formatServicetoDo() {
    this.servicesToDoState = this.servicesToDo.map((s) => {
      const service: IServiceTodo = {
        Name: s.Name,
        Selected: false,
        Price: s.BasePrice || null,
      };
      return service;
    });
  }

  getComment(service: IServiceTodo): string {
    const currentService:
      | IServiceTodoDefinition
      | undefined = this.servicesToDo.find((s) => s.Name === service.Name);
    return currentService && currentService!.Comment
      ? `(${currentService.Comment})`
      : "";
  }

  getPriceType(service: IServiceTodo): string {
    const currentService:
      | IServiceTodoDefinition
      | undefined = this.servicesToDo.find((s) => s.Name === service.Name);
    return currentService && currentService!.PriceType
      ? `${currentService.PriceType}`
      : "";
  }

  getRequiresQA(service: IServiceDone): boolean {
    const currentService:
      | IServiceDoneDefinition
      | undefined = this.servicesDone.find((s) => s.Name === service.Name);
    return currentService && currentService!.RequiresQA ? true : false;
  }

  async getWorkOrder() {
    if (this.id) {
      this.buttonLoading = true;
      const resp = await GetWorOrder(this.id);
      this.workOrder = resp.WorkOrder;
      if (this.workOrder.Deadline) {
        this.workOrder.Deadline = formatDate(
          this.workOrder.Deadline!,
          "yyyy-MM-dd"
        );
      }
      this.servicesToDoState = resp.ServicesToDo;
			this.servicesDoneState = resp.ServicesDone;
			this.defaultCustomer = resp.WorkOrder.CustomerID;
      if (!this.servicesDoneState.length) this.formatServiceDone();
      this.buttonLoading = false;
    }
  }

  async searchCustomer(value: string | number): Promise<ICustomer[]> {
    if (typeof value === "number") {
      const resp = await GetCustomer(value);
      return resp.Ok ? [resp.Customer] : [];
    } else {
      const resp = await SearchCustomers(value, 0, 5);
      return resp.Ok ? resp.Results.Customers : [];
    }
  }

  get section() {
    let from = "";
    if (this.type === "technician") {
      from = "Tech Admin";
    } else if (this.type === "office") {
      from = "Office Admin";
    } else if (this.type === "shop-manager") {
      from = "Shop Manager";
    }
    return `${from}`;
  }

  get title() {

		var title = 'Work Order';

		if ( this.$route.meta.IsEditing){
			title = "Editing Work Order #" + this.id;
		}

		if ( this.$route.meta.IsCreating){
			title = "Creating Work Order";
		}

		if ( this.$route.meta.IsViewing){
			title = "Viewing Work Order #" + this.id;
		}

		return title;

    // if (this.type === "shop-manager") {
    //   return "Viewing Work Order #" + this.id;
    // }

    // return this.id ? "Editing Work Order #" + this.id : "Creating Work Order";
  }

  get buttonLabel() {
    return this.id ? "Update Work Order" : "Insert Work Order";
  }

  updateCustomer(customer: ICustomer) {
    this.workOrder.CustomerID = customer.RecordID!;
  }

  async validate() {
    if ((this.$refs.workOrderForm as HTMLFormElement).validate()) {
      let workOrder = { ...this.workOrder };
      try {
        // Format work order
        if (workOrder.Deadline) {
          const splitDate = workOrder.Deadline.split("-");
          workOrder.Deadline = `${splitDate[1]}/${splitDate[2]}/${splitDate[0]}`;
        }

        // Format service todo
        this.servicesToDoState = this.servicesToDoState.map((s) => {
          if (!s.Price) delete s.Price;
          s.Price = Number(s.Price);
          return s;
        });

        // Format service done
        this.servicesDoneState = this.servicesDoneState.map((s) => {
          if (!s.DoneBy) delete s.DoneBy;
          if (!s.DoneQaBy) delete s.DoneQaBy;
          return s;
        });

        this.buttonLoading = true;

        this.id
          ? this.type === "technician"
            ? this.updateTech(workOrder)
            : this.updateOffice(workOrder)
          : this.insert(workOrder);
      } catch (err) {
        //
      }
    }
  }

  showServiceDone() {
    return this.type !== "office";
  }

  async insert(workOrder: IWorkOrder) {
    const resp = await InsertWorOrder(workOrder, this.servicesToDoState);
    this.buttonLoading = false;
    if (resp.Ok) this.complete();
  }

  async updateOffice(workOrder: IWorkOrder) {
    const resp = await UpdateWorOrderOffice(workOrder, this.servicesToDoState);
    this.buttonLoading = false;
    if (resp.Ok) this.complete();
  }

  async updateTech(workOrder: IWorkOrder) {
    const resp = await UpdateWorOrderTech(workOrder, this.servicesDoneState);
    this.buttonLoading = false;
    if (resp.Ok) this.complete();
  }

  complete() {
    this.$router.push(this.redirect);
    this.setSnackbarAction({
      message: `Work order ${this.id ? "edited" : "added"} successfully`,
      status: "success",
    });
  }
}


